import styled from 'styled-components';
import fonts from '../../ui/fonts';
import { space, media, rems } from '../../ui/helpers';
import { colors } from '../../ui/design-tokens';

const Container = styled.div`
  align-items: center;
  background: ${colors.neutral[900]};
  color: ${colors.neutral[100]};
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 70px;
  padding: ${space(4)} ${space(3)} ${space(2)};
  pointer-events: initial;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 9999; /* needs to be greedy */

  .close {
    display: flex;
    position: absolute;
    right: ${space(2)};
    top: ${space(2)};

    .svg {
      height: ${rems(12)};
      width: ${rems(12)};

      path {
        fill: ${colors.neutral[100]};
      }
    }

    &:hover {
      cursor: pointer;
    }
  }

  .text {
    ${fonts.bodySM};
    margin-bottom: ${space(2)};
    text-align: center;
  }

  .buttons {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;

    .btn {
      margin: 0 ${space(1)} ${space(2)} ${space(1)};
    }
  }

  ${media.min('medium')`
    flex-direction: row;
    padding: ${space(1)} ${space(1)} ${space(2)};

    .close {
        right: ${space(1)};
        top: ${space(1)};
    }

    .buttons {
        .btn {
            margin: 0 ${space(1)};
        }
    }

    .text{
        margin-bottom: 0;
        margin-right: ${space(2)};
    }
  `}
`;

export { Container };
